'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class; // Lib


// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _selectionMarqueeStateDecorator = require('./selectionMarqueeStateDecorator');

var _selectionMarqueeStateDecorator2 = _interopRequireDefault(_selectionMarqueeStateDecorator);

var _selectionMarqueeMouseEventHandlerDecorator = require('./selectionMarqueeMouseEventHandlerDecorator');

var _selectionMarqueeMouseEventHandlerDecorator2 = _interopRequireDefault(_selectionMarqueeMouseEventHandlerDecorator);

var _selectionMarqueeSelectedElementFinderDecorator = require('./selectionMarqueeSelectedElementFinderDecorator');

var _selectionMarqueeSelectedElementFinderDecorator2 = _interopRequireDefault(_selectionMarqueeSelectedElementFinderDecorator);

require('./SelectionMarquee.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectionMarquee = (0, _selectionMarqueeStateDecorator2.default)(_class = (0, _selectionMarqueeSelectedElementFinderDecorator2.default)(_class = (0, _selectionMarqueeMouseEventHandlerDecorator2.default)(_class = function (_React$Component) {
    _inherits(SelectionMarquee, _React$Component);

    function SelectionMarquee() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SelectionMarquee);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectionMarquee.__proto__ || Object.getPrototypeOf(SelectionMarquee)).call.apply(_ref, [this].concat(args))), _this), _this.getMarqueePositionStyle = function () {
            var _this$props = _this.props,
                top = _this$props.top,
                left = _this$props.left,
                width = _this$props.width,
                height = _this$props.height;

            return { top: top, left: left, width: width, height: height };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SelectionMarquee, [{
        key: 'render',
        value: function render() {
            if (!this.props.active) return null;
            return _react2.default.createElement('div', { className: 'SelectionMarquee', style: this.getMarqueePositionStyle() });
        }
    }]);

    return SelectionMarquee;
}(_react2.default.Component)) || _class) || _class) || _class;

SelectionMarquee.propTypes = {
    active: _propTypes2.default.bool,
    top: _propTypes2.default.number,
    left: _propTypes2.default.number,
    width: _propTypes2.default.number,
    height: _propTypes2.default.number
};

exports.default = SelectionMarquee;


//////////////////
// WEBPACK FOOTER
// ./src/client/canvas/selection/SelectionMarquee.js
// module id = 1694
// module chunks = 0